import { ref } from 'vue'

function readCollapsedKeys(storageKey: string): Set<string> {
  if (typeof window === 'undefined') return new Set()

  try {
    const storedValue = window.sessionStorage.getItem(storageKey)
    if (!storedValue) return new Set()

    const parsedValue: unknown = JSON.parse(storedValue)
    if (!Array.isArray(parsedValue)) return new Set()

    return new Set(parsedValue.filter((value): value is string => typeof value === 'string'))
  } catch {
    return new Set()
  }
}

function writeCollapsedKeys(storageKey: string, collapsedKeys: Set<string>): void {
  if (typeof window === 'undefined') return

  try {
    if (collapsedKeys.size === 0) {
      window.sessionStorage.removeItem(storageKey)
      return
    }

    window.sessionStorage.setItem(storageKey, JSON.stringify([...collapsedKeys]))
  } catch {
    return
  }
}

export function useSessionAccordionState(storageKey: string) {
  const collapsedKeys = ref(readCollapsedKeys(storageKey))

  function isOpen(key: string): boolean {
    return !collapsedKeys.value.has(key)
  }

  function setOpen(key: string, open: boolean): void {
    const nextCollapsedKeys = new Set(collapsedKeys.value)

    if (open) {
      nextCollapsedKeys.delete(key)
    } else {
      nextCollapsedKeys.add(key)
    }

    collapsedKeys.value = nextCollapsedKeys
    writeCollapsedKeys(storageKey, nextCollapsedKeys)
  }

  return {
    isOpen,
    setOpen,
  }
}
